"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "19",
    height: "35",
    style: style
  }, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    id: "iPhoneX-path-a",
    d: "M0 0h19v35H0z"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "iPhoneX-mask-b",
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#iPhoneX-path-a"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17 31.038C17 32.12 16.12 33 15.038 33H3.962A1.964 1.964 0 0 1 2 31.038V3.962C2 2.88 2.88 2 3.962 2h.871v.863c0 .628.51 1.137 1.138 1.137h7.059c.628 0 1.137-.509 1.137-1.137V2h.871C16.12 2 17 2.88 17 3.962v27.076zM15.038 0H3.962A3.966 3.966 0 0 0 0 3.962v27.076A3.966 3.966 0 0 0 3.962 35h11.076A3.966 3.966 0 0 0 19 31.038V3.962A3.966 3.966 0 0 0 15.038 0z",
    fill: "#FFF",
    mask: "url(#iPhoneX-mask-b)"
  })));
};

exports["default"] = _default;